import React, { useState } from 'react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../../../../../../../components/Common/UI/DropDown';
import Icons from '../../../../../../../components/Common/Icons/Icons';
import ModalDeleteUser from '../Modals/Delete';
import ModalLinkUser from '../Modals/LinkUser';
import { AccountManagementSubRow } from '../../../columns';

export type IModalType = 'delete' | 'link';

export interface IModalProps {
  open: boolean;
  handleOpen: (payload: boolean, modalType: IModalType) => void;
}

interface IModalState {
  delete: boolean;
  link: boolean;
}

interface IUserInfoSelect {
  selected?: AccountManagementSubRow;
  handleSelect: (payload: AccountManagementSubRow) => void;
  users: AccountManagementSubRow[];
  handleDeleteUser: () => void;
}

function UserInfoSelect({ selected, handleSelect, users, handleDeleteUser }: IUserInfoSelect) {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isUnroll, setIsUnroll] = useState<boolean>(true);
  const [modalState, setModalState] = useState<IModalState>({ delete: false, link: false });

  const handleModalOpen = (payload: boolean, modalType: IModalType) => {
    setModalState({
      ...modalState,
      [modalType]: payload,
    });

    if (!payload) {
      setTimeout(() => document.body.removeAttribute('style'), 200);
    }
  };

  const handleUnroll = () => {
    setIsUnroll(!isUnroll);
  };

  return (
    <>
      <DropdownMenu open={isOpen} onOpenChange={e => setIsOpen(e)}>
        <DropdownMenuTrigger onClick={() => setIsOpen(true)}>
          <div className="bg-primary py-[10px] px-[20px] rounded-lg flex items-center gap-[5px] text-white">
            {selected?.name || ''}
            <Icons.ArrowRight className="rotate-90 ml-[5px] h-[20px] w-[20px] shrink-0 opacity-50" />
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          {users.map(el => (
            <DropdownMenuItem key={el.id} onClick={() => handleSelect(el)}>
              {el.name}
            </DropdownMenuItem>
          ))}
          <DropdownMenuSeparator />
          <DropdownMenuItem className="flex gap-[10px] items-center">
            <Icons.PlusFilled className="w-[24px]" />
            Add User
          </DropdownMenuItem>
          <DropdownMenuItem className="flex gap-[10px] items-center" onClick={() => handleModalOpen(true, 'link')}>
            <Icons.UnlinkUser className="w-[24px]" />
            Unlink User
          </DropdownMenuItem>
          <DropdownMenuItem className="flex gap-[10px] items-center" onClick={() => handleModalOpen(true, 'delete')}>
            <Icons.DeleteIconNew className="[&_path]:fill-primary w-[24px]" />
            <div className="text-primary text-[16px] font-medium">Delete User</div>
          </DropdownMenuItem>
          <DropdownMenuItem className="flex gap-[10px] items-center" onClick={handleUnroll}>
            <Icons.InsertPage className="w-[24px]" />
            {isUnroll ? 'Unroll User' : 'Roll User'}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <ModalDeleteUser handleOpen={handleModalOpen} open={modalState.delete} handleDeleteUser={handleDeleteUser} />
      <ModalLinkUser open={modalState.link} handleOpen={handleModalOpen} />
    </>
  );
}

UserInfoSelect.defaultProps = {
  selected: undefined,
};

export default UserInfoSelect;
